module.exports = __webpack_public_path__ + "img/switchsegnalaoff.b0daffb2.png";